import React, { useEffect, useRef, useState } from "react";

import Icon from "../../../../components/Icon";
import ButtonCheckbox from "../../../../components/ButtonCheckbox";

// Vazio significa "todas": assim conta criada depois entra sozinha no recorte
// de quem não escolheu nenhuma.
export const BankAccountMultiSelect = ({ accounts, value, onChange }) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = event => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selected = value.filter(id => accounts.some(account => account.id === id));
    const allSelected = selected.length === 0;

    const toggle = id => {
        const next = selected.includes(id) ? selected.filter(item => item !== id) : [...selected, id];
        onChange(next.length === accounts.length ? [] : next);
    };

    const label = allSelected
        ? 'Todas as contas'
        : selected.length === 1
            ? accounts.find(account => account.id === selected[0])?.name
            : `${selected.length} contas`;

    return (
        <div className="finance-account-select" ref={containerRef}>
            <button type="button" className={`account-select-toggle${open ? ' open' : ''}`} onClick={() => setOpen(!open)}>
                <span>{label}</span>
                <Icon name="arrow-dropdown" size={16} />
            </button>
            {open &&
                <div className="account-select-menu">
                    <label className="account-option">
                        <ButtonCheckbox checked={allSelected} onClick={() => onChange([])} />
                        <span>Selecionar todas</span>
                    </label>
                    {accounts.map(account => (
                        <label className="account-option" key={account.id}>
                            <ButtonCheckbox checked={!allSelected && selected.includes(account.id)} onClick={() => toggle(account.id)} />
                            <span>{account.name}</span>
                        </label>
                    ))}
                    {accounts.length === 0 && <span className="account-empty">Nenhuma conta cadastrada.</span>}
                </div>
            }
        </div>
    );
};

export default BankAccountMultiSelect;
